import type { Theme } from '../types';

const getProductColorMapper =
  (product: Theme.Utility.ThemeSites) =>
  (colorMap: Partial<{ [key in Theme.Utility.ThemeSites]: string }>): string =>
    colorMap[product] ?? Object.values(colorMap)[0];

export default getProductColorMapper;
